// extracted by mini-css-extract-plugin
module.exports = {"image":"svg-pure-icon_image__2kBPG"};